import { Component, computed, inject, input } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PrimeNGModule } from '@shared/primeng/primeng.module';

import { formatKlDateValue } from '../../utils/kl-date-format';

export type KlRecordHistoryTab = { tab_name: string; tab_header: string };

@Component({
  selector: 'kl-record-history-dialog',
  standalone: true,
  imports: [TranslateModule, PrimeNGModule],
  templateUrl: './kl-record-history-dialog.html',
  styleUrl: './kl-record-history-dialog.scss',
})
export class KlRecordHistoryDialogComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly translate = inject(TranslateService);

  /** API `GET …/history` body merged with `historyPrefix` (legacy `dataContext`). */
  readonly entity = input<Record<string, unknown>>({});

  readonly tabs = computed((): KlRecordHistoryTab[] => {
    const e = this.entity();
    if (!e || typeof e !== 'object') return [];
    const prefix = String(e['historyPrefix'] ?? '');
    const out: KlRecordHistoryTab[] = [];
    for (const key of Object.keys(e)) {
      if (key === 'persist_user' || key === 'historyPrefix') continue;
      const col = e[key];
      if (!Array.isArray(col)) continue;
      const tab_header =
        key === 'entity' || key === 'header' ? 'general' : prefix ? key.replace(prefix + '_', '') : key;
      out.push({ tab_name: key, tab_header });
    }
    return out;
  });

  persistUser(): Record<string, unknown> | null {
    const u = this.entity()['persist_user'];
    return u && typeof u === 'object' ? (u as Record<string, unknown>) : null;
  }

  historiesFor(tabName: string): unknown[] {
    const v = this.entity()[tabName];
    return Array.isArray(v) ? v : [];
  }

  fmtDt(value: unknown): string {
    if (value == null || value === '') return '';
    return formatKlDateValue(value, true);
  }

  transLabel(transType: string | undefined): string {
    if (transType === 'update') return this.translate.instant('updated');
    if (transType === 'insert') return this.translate.instant('inserted');
    return this.translate.instant('deleted');
  }

  close(): void {
    this.ref.close();
  }
}
